import { judgeAcmg } from '@/@core/layouts/utils'
import { formatDate } from '@/@core/utils/utils'
import { DEL_evidences, DUP_evidences } from '../CurrentRepoet'

export const getTemplate2 = (
  report: any,
  reportValue: any,
  reportsVariants: any[],
  reportsVariantsType: any,
  props: any,
  t: any
) => {
  return [
    {
      type: 'block-title',
      children: [
        {
          text: '/images/logos/genomelight_logo.png'
        }
      ]
    },
    {
      type: 'header2',
      children: [
        {
          text: '基因分析报告'
        }
      ]
    },
    {
      type: 'header4',
      children: [{ text: '患者信息' }]
    },
    {
      type: 'block-patient-info',
      children: [
        {
          type: 'p3',
          children: [
            {
              text: `样本ID：${reportValue.sample?.id ?? '-'}`
            }
          ]
        },
        {
          type: 'p3',
          children: [
            {
              text: `姓名：${reportValue.patient?.patientName ?? '-'}`
            }
          ]
        },
        {
          type: 'p3',
          children: [
            {
              text: `送检医院：${reportValue?.patient?.infirmaryName ?? '-'}`
            }
          ]
        },
        {
          type: 'p3',
          children: [
            {
              text: `科室：${reportValue?.patient?.departmentName ?? '-'}`
            }
          ]
        },
        {
          type: 'p3',
          children: [
            {
              text: `病例号：${reportValue?.patient?.caseNumber ?? '-'}`
            }
          ]
        },
        {
          type: 'p3',
          children: [
            {
              text: `性别：${t(
                (reportValue?.patient?.gender as string) ?? '-'
              )}`
            }
          ]
        },
        {
          type: 'p3',
          children: [
            {
              text: `样本类型：${reportValue?.sample?.vcfType?.toLocaleUpperCase()}`
            }
          ]
        },
        {
          type: 'p3',
          children: [
            {
              text: `样本：${reportValue?.sample?.name}`
            }
          ]
        },
        {
          type: 'p3',
          children: [
            {
              text: `年龄：${
                reportValue.patient?.dateOfBirth
                  ? (Math.floor(
                      (new Date().valueOf() -
                        new Date(reportValue.patient?.dateOfBirth).valueOf()) /
                        3.15576e10
                    ) <= 0
                      ? 0
                      : Math.floor(
                          (new Date().valueOf() -
                            new Date(
                              reportValue.patient?.dateOfBirth
                            ).valueOf()) /
                            3.15576e10
                        )) + '岁'
                  : '-'
              }`
            }
          ]
        },
        {
          type: 'p3',
          children: [
            {
              text: `医生姓名：${reportValue.patient?.physicianName ?? '-'}`
            }
          ]
        },
        {
          type: 'p3',
          children: [
            {
              text: `接收日期：${
                formatDate(reportValue.patient?.arrivalDate) ?? '-'
              }`
            }
          ]
        },
        {
          type: 'p3',
          children: [
            {
              text: `民族：${t(
                (reportValue.patient?.ethnicity as string) ?? '-'
              )}`
            }
          ]
        },
        {
          type: 'p3',
          children: [
            {
              text: `患者电话：${reportValue.patient?.phone ?? '-'}`
            }
          ]
        },
        {
          type: 'p3',
          children: [
            {
              text: `报告日期：${formatDate(report?.createdAt) ?? '-'}`
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: '检测项目：'
        },
        {
          text: reportValue.sample?.vcfType ?? '-'
        }
      ]
    },
    {
      type: 'header3',
      children: [
        {
          text: '临床信息：'
        }
      ]
    },
    {
      type: 'paragraph',
      children: [
        {
          text: reportsVariantsType.KeyFinding?.OMIMCN ?? '-'
        }
      ]
    },
    {
      type: 'header3',
      children: [
        {
          text: '检测结果：'
        }
      ]
    },
    {
      type: 'header4',
      children: [
        {
          text: report?.result === 'positive' ? '阳性' : '阴性'
        }
      ]
    },
    {
      type: 'paragraph',
      children: [
        {
          text:
            report?.result === 'positive'
              ? '检测到可以解释临床信息的致病性基因变异'
              : '未检测到可以明确解释临床信息的致病性/疑似致病性基因变异'
        }
      ]
    },
    {
      type: 'header3',
      children: [
        {
          text: '结果详情:'
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-color',
              children: [{ text: '基因' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: '碱基变化' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: 'gAD_EAS	' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: '纯合性' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: '遗传方式' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: 'ACMG' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: '类型' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: '疾病名称' }]
            }
          ]
        },

        ...reportsVariants
          .filter((item) => item.variantsType === 'KeyFinding')
          .map((row) => {
            return {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph-gene',
                      children: [
                        {
                          text: `${row.gene}`
                        }
                      ]
                    },
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.transcript ?? '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text:
                            row.chrom && row.pos
                              ? `${row.chrom}:${row.pos}:${row.nuc_change}`
                              : row.chrom && row.SV_start
                              ? `${row.chrom}:${row.SV_start}:${row.SV_end}`
                              : ''
                        }
                      ]
                    },
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.c_nomen ?? '-'
                        }
                      ]
                    },
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.p_nomen ?? '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `${row.gnomAD_exome_EAS ?? '-'}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.coverage ?? '-'
                        }
                      ]
                    },
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.allele_frequency
                            ? row.allele_frequency < 0.85
                              ? t('heterozygote')
                              : t('homozygote')
                            : '无'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.inheritance
                            ? row.inheritance
                            : row.omim_info
                            ? row.omim_info
                                .map((i: any) => i.inheritance)
                                .join(';')
                            : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.user_acmg_classification
                            ? row.user_acmg_classification
                                ?.split(' ')
                                .map((word: string) => {
                                  if (word.includes('Uncertain')) return `VU`
                                  if (word.includes('uncertain')) return `VU`
                                  if (word.includes('null')) return ``
                                  else return word[0].toUpperCase()
                                })
                                .join('')
                            : row.ACMG_classification
                            ? row.ACMG_classification?.split(' ')
                                .map((word: string) => {
                                  if (word.includes('Uncertain')) return `VU`
                                  if (word.includes('uncertain')) return `VU`
                                  if (word.includes('null')) return ``
                                  else return word[0].toUpperCase()
                                })
                                .join('')
                            : row.classification
                            ? row.classification
                                ?.split(' ')
                                .map((word: string) => {
                                  if (word.includes('Uncertain')) return `VU`
                                  if (word.includes('uncertain')) return `VU`
                                  if (word.includes('null')) return ``
                                  else return word[0].toUpperCase()
                                })
                                .join('')
                            : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: t(row.variantsType)
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.OMIMCN
                            ? row.OMIMCN
                            : row.omim_info
                            ? row.omim_info
                                .map((i: any) => i.pheno_name_cn)
                                .join(';')
                            : ''
                        }
                      ]
                    },
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.OMIM?.geneMim
                            ? `OMIM ID: ${row.OMIM?.geneMim}`
                            : ''
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          })
      ]
    },
    {
      type: 'header3',
      children: [
        {
          text: '主要发现疾病描述：'
        }
      ]
    },

    ...[
      ...reportsVariants
        .filter((item) => item.variantsType === 'KeyFinding')
        .map((item) => {
          const type =
            item.SV_type === 'del' || item.SV_type === 'DEL' ? 'DEL' : 'DUP'
          const list = type === 'DEL' ? DEL_evidences : DUP_evidences

          return [
            {
              type: 'paragraph',
              children:
                item.newOMIMData && item.newOMIMData.length
                  ? item.newOMIMData?.map((i: any) => {
                      return {
                        type: 'paragraph',
                        children: [
                          {
                            type: 'paragraph',
                            children: [
                              {
                                type: 'h3',
                                text: `${i.genetic_mode ?? '-'}--${i.disease}`
                              }
                            ]
                          },
                          {
                            type: 'paragraph',
                            text: `${
                              i?.disease_description_cn ?? t('No Results')
                            }`
                          }
                        ]
                      }
                    })
                  : item.OMIMData && item.OMIMData.length
                  ? item.OMIMData?.map((i: any) => {
                      return {
                        type: 'paragraph',
                        children: [
                          {
                            type: 'paragraph',
                            children: [
                              {
                                type: 'h3',
                                text: `${i.pheno_name_cn ?? '-'}`
                              }
                            ]
                          },
                          {
                            type: 'paragraph',
                            text: `${
                              i?.phenoClinicalFeaturesCNStr?.join('\n') ??
                              t('No Results')
                            }`
                          }
                        ]
                      }
                    })
                  : item.MitoMap && item.MitoMap.disease_ch
                  ? [
                      {
                        type: 'paragraph',
                        children: [
                          {
                            type: 'paragraph',
                            children: [
                              {
                                type: 'h3',
                                text: `${item.MitoMap.disease_ch ?? '-'}`
                              }
                            ]
                          },
                          {
                            type: 'paragraph',
                            text: `${item.MitoMap.info ?? t('No Results')}`
                          }
                        ]
                      }
                    ]
                  : item.AnnotSV_ID
                  ? [
                      {
                        type: 'paragraph',
                        children: [
                          {
                            type: 'paragraph',
                            children: [
                              {
                                type: 'h3',
                                text: `seq[${props.analysisInfo.genomeBuild}]${
                                  item.SV_type
                                }(2)(p16.3)
chr${item.chrom}:${item.SV_start}:${item.SV_end}该样本${
                                  item.chrom
                                }号染色体短臂 2p16.3存在大小约 ${(
                                  item.LEN / 1024
                                ).toFixed(0)}Kb 的拷贝数缺失(拷贝数 =${
                                  item.CN
                                })，该变异初步判定为疑似致病性变异(${
                                  item.ccnv_classification
                                }):
Decipher 数据库和 OMIM 数据库中相关综合征未见报道。该区域部分覆盖明确的单倍剂量敏感基因 ${item.gene_info?.omim_disease_genes
                                  .map((item: any) => item.symbol)
                                  .join(';')}，包括编码区域。该区域内包含${
                                  item.gene_info?.omim_disease_genes?.length
                                }个编码基因。ClinVar 数据库中未见报道。`
                              }
                            ]
                          },
                          {
                            type: 'paragraph',
                            children: [
                              {
                                type: 'h3',
                                text: `证据:`
                              }
                            ]
                          },
                          ...item.ClassifyCNV_evidences.split(',').map(
                            (item: any, index: number) => {
                              const temp = list.find((i) => i.key === item)

                              return {
                                type: 'paragraph',
                                children: [
                                  {
                                    type: 'h3',
                                    text: `${item}(0):${temp?.value}`
                                  }
                                ]
                              }
                            }
                          ),
                          {
                            type: 'paragraph',
                            children: [
                              {
                                type: 'h3',
                                text: ``
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  : [
                      {
                        type: 'paragraph',
                        text: ''
                      }
                    ]
            }
          ]
        })
        .flat()
    ],
    {
      type: 'header3',
      children: [
        {
          text: '基因和变异的详细信息：'
        }
      ]
    },
    ...[
      ...reportsVariants
        .filter((item) => item.variantsType === 'KeyFinding')
        .filter((item) => item.Details)
        .map((item) => {
          return [
            {
              type: 'paragraph',
              children: [
                {
                  text: item.Details
                    ? `${item.Details?.variantInfo?.gene}: ${item.Details?.geneInfo?.functionZh}`
                    : ''
                }
              ]
            },
            {
              type: 'paragraph',
              children: [
                {
                  text: ''
                }
              ]
            },
            {
              type: 'paragraph',
              children: [
                {
                  text: item.Details
                    ? `${item.Details?.variantInfo?.gene}为${
                        item.Details?.variantInfo?.allele_frequency < 0.85
                          ? '杂合'
                          : '纯合'
                      }, ${judgeAcmg(
                        item.Details.variantInfo?.user_acmg_classification
                          ? item.Details.variantInfo?.user_acmg_classification
                          : item.Details.variantInfo?.ACMG_classification
                      )}。${item.Details.variantInfo?.c_nomen} (  ${
                        item.Details.variantInfo?.p_nomen
                      } )，该变异在Gnomad中的最高人群频率是${
                        item.Details.variantInfo?.gnomAD_exome_ALL
                      }。此变异是 ${
                        item.Details.acmgCN
                      }。 根据证据，这个错义变异在临床意义上被分类为${judgeAcmg(
                        item.Details.variantInfo?.user_acmg_classification
                          ? item.Details.variantInfo?.user_acmg_classification
                          : item.Details.variantInfo?.ACMG_classification
                      )}。`
                    : ''
                }
              ]
            },
            {
              type: 'paragraph',
              children: [
                {
                  text: ''
                }
              ]
            }
          ]
        })
        .flat()
    ],
    {
      type: 'paragraph',
      children: [
        {
          text: '附：其他基因变异'
        }
      ]
    },
    {
      type: 'header3',
      children: [
        {
          text: '结果详情 : （附：其他基因变异）'
        }
      ]
    },
    {
      type: 'table-available',
      children: [
        {
          type: 'table-row',
          children: [
            {
              type: 'table-cell-color',
              children: [{ text: '基因' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: '碱基变化' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: 'gAD_EAS' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: '纯合性' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: '遗传方式' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: 'ACMG' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: '类型' }]
            },
            {
              type: 'table-cell-color',
              children: [{ text: '疾病名称' }]
            }
          ]
        },
        ...reportsVariants
          .filter((item) => item.variantsType !== 'KeyFinding')
          .map((row) => {
            return {
              type: 'table-row',
              children: [
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph-gene',
                      children: [
                        {
                          text: `${row.gene}`
                        }
                      ]
                    },
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.transcript ?? '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text:
                            row.chrom && row.pos
                              ? `${row.chrom}:${row.pos}:${row.nuc_change}`
                              : row.chrom && row.SV_start
                              ? `${row.chrom}:${row.SV_start}:${row.SV_end}`
                              : ''
                        }
                      ]
                    },
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.c_nomen ?? '-'
                        }
                      ]
                    },
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.p_nomen ?? '-'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: `${row.gnomAD_exome_EAS}`
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.coverage ?? '-'
                        }
                      ]
                    },
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.allele_frequency
                            ? row.allele_frequency < 0.85
                              ? t('heterozygote')
                              : t('homozygote')
                            : '无'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.inheritance
                            ? row.inheritance
                            : row.omim_info
                            ? row.omim_info
                                .map((i: any) => i.inheritance)
                                .join(';')
                            : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.user_acmg_classification
                            ? row.user_acmg_classification
                                ?.split(' ')
                                .map((word: string) => {
                                  if (word.includes('Uncertain')) return `VU`
                                  if (word.includes('uncertain')) return `VU`
                                  if (word.includes('null')) return ``
                                  else return word[0].toUpperCase()
                                })
                                .join('')
                            : row.ACMG_classification
                            ? row.ACMG_classification?.split(' ')
                                .map((word: string) => {
                                  if (word.includes('Uncertain')) return `VU`
                                  if (word.includes('uncertain')) return `VU`
                                  if (word.includes('null')) return ``
                                  else return word[0].toUpperCase()
                                })
                                .join('')
                            : row.classification
                            ? row.classification
                                ?.split(' ')
                                .map((word: string) => {
                                  if (word.includes('Uncertain')) return `VU`
                                  if (word.includes('uncertain')) return `VU`
                                  if (word.includes('null')) return ``
                                  else return word[0].toUpperCase()
                                })
                                .join('')
                            : ''
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: t(row.variantsType)
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'table-cell',
                  children: [
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.OMIMCN ?? '-'
                        }
                      ]
                    },
                    {
                      type: 'paragraph',
                      children: [
                        {
                          text: row.OMIM?.geneMim
                            ? `OMIM ID: ${row.OMIM?.geneMim}`
                            : ''
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          })
      ]
    },
    {
      type: 'header3',
      children: [
        {
          text: '次要发现疾病描述：'
        }
      ]
    },

    ...[
      ...reportsVariants
        .filter((item) => item.variantsType !== 'KeyFinding')
        .filter((item) => item.OMIMData)
        .map((item) => {
          return [
            {
              type: 'paragraph',
              children:
                item.newOMIMData && item.newOMIMData.length
                  ? item.newOMIMData?.map((i: any) => {
                      return {
                        type: 'paragraph',
                        children: [
                          {
                            type: 'paragraph',
                            children: [
                              {
                                type: 'h3',
                                text: `${i.genetic_mode ?? '-'}--${i.disease}`
                              }
                            ]
                          },
                          {
                            type: 'paragraph',
                            text: `${
                              i?.disease_description_cn ?? t('No Results')
                            }`
                          }
                        ]
                      }
                    })
                  : item.OMIMData && item.OMIMData.length
                  ? item.OMIMData?.map((i: any) => {
                      return {
                        type: 'paragraph',
                        children: [
                          {
                            type: 'paragraph',
                            children: [
                              {
                                type: 'h3',
                                text: `${i.pheno_name_cn ?? '-'}`
                              }
                            ]
                          },
                          {
                            type: 'paragraph',
                            text: `${
                              i?.phenoClinicalFeaturesCNStr?.join('\n') ??
                              t('No Results')
                            }`
                          }
                        ]
                      }
                    })
                  : item.MitoMap && item.MitoMap.disease_ch
                  ? [
                      {
                        type: 'paragraph',
                        children: [
                          {
                            type: 'paragraph',
                            children: [
                              {
                                type: 'h3',
                                text: `${item.MitoMap.disease_ch ?? '-'}`
                              }
                            ]
                          },
                          {
                            type: 'paragraph',
                            text: `${item.MitoMap.info ?? t('No Results')}`
                          }
                        ]
                      }
                    ]
                  : [
                      {
                        text: ''
                      }
                    ]
            }
          ]
        })
        .flat()
    ],
    {
      type: 'header3',
      children: [
        {
          text: '基因和变异的详细信息：'
        }
      ]
    },

    ...[
      ...reportsVariants
        .filter((item) => item.variantsType !== 'KeyFinding')
        .filter((item) => item.Details)
        .map((item) => {
          return [
            {
              type: 'paragraph',
              children: [
                {
                  text: item.Details
                    ? `${item.Details?.variantInfo?.gene}: ${
                        item.Details?.geneInfo?.functionZh ?? '-'
                      }`
                    : ''
                }
              ]
            },
            {
              type: 'paragraph',
              children: [
                {
                  text: ''
                }
              ]
            }
          ]
        })
        .flat()
    ],
    {
      type: 'header3',
      children: [
        {
          text: '测序方法：'
        }
      ]
    },
    {
      type: 'paragraph',
      children: [
        {
          text: '使用安捷伦的 SureSelect 人类全外显子 V6 试剂盒，使用针对大约 60 Mb 人类外显子组（靶向 CCDS、RefSeq 和 Gencode 数据库中 >99% 的区域）的 RNA 捕获诱饵，从片段化的基因组 DNA 中富集感兴趣的区域。生成的文库在Illumina平台上进行测序，以获得~50倍的平均覆盖深度。在这个样本中，已经对大约25，000个基因进行了测序，其中的目标10x至少覆盖了>10x。应用端到端的内部生物信息学管道，包括碱基调用、读段与 GRCh37/hg19 基因组组装的比对、低质量读段和可能的伪影的初级过滤，以及随后的变体注释。大约，考虑在 HGMD®、ClinVar 中报告的所有致病变异以及 gnomAD 数据库中次要等位基因频率 （MAF） 小于 1% 的所有变异。评估的重点是编码外显子以及侧翼+/-20内含子碱基。考虑所有相关的继承模式。此外，提供的家族史和临床信息用于评估最终确定的变异。对所有已识别的变异的致病性和因果关系进行评估，并将其分为1-5类（见上文）。报告了与患者表型相关的所有变异，良性或可能的良性变异除外。NGS确定的相关变体在内部持续和单独地进行质量方面的验证;那些符合我们内部质量控制标准（基于广泛的验证流程）的变体未经 Sanger 验证。'
        }
      ]
    },
    {
      type: 'header3',
      children: [
        {
          text: '局限性：'
        }
      ]
    },
    {
      type: 'paragraph',
      children: [
        {
          text: '根据临床发现、家族史和其他实验室数据来解释测试结果。仅报告与先证者的医疗状况可能相关的基因变异。罕见的多态性可能导致假阴性或假阳性结果。如果提供的信息不准确或不完整，则可能会对结果产生误解。如果获得的结果与临床发现不符，应考虑进行其他检查。特定的遗传事件，如拷贝数变异、易位和重复扩增，可能无法通过外显子组测序可靠地检测到。此外，由于技术的限制，某些区域可能没有被覆盖，或者可能覆盖得很差，在这些地区无法可靠地检测到变异株。'
        }
      ]
    },
    {
      type: 'header3',
      children: [
        {
          text: '附加信息：'
        }
      ]
    },
    {
      type: 'paragraph',
      children: [
        {
          text: '该测试由GenomeLight开发并验证其性能。该测试是为临床目的而开发的, 所有测试结果均由我们的科学和医学专家审查、解释和报告。根据acmg关于报告临床外显子组和基因组测序偶然发现的建议（医学遗传学，2016），我们仅报告推荐表型的推荐基因中的偶然发现，即致病变异（1类）和可能的致病变异（2类）。为了在临床中排除错误的身份，一些指南建议测试独立于先证者的第二个样本。请注意，任何进一步的分析都将导致额外费用。变异的分类可能会随着时间的推移而变化。请随时联系GenomeLight 基诺莱（重庆）生物技术有限公司（info@genomelight.com），以确定任何报告的变体的分类是否有任何变化。'
        }
      ]
    },
    {
      type: 'header3',
      children: [
        {
          text: 'GLsofort'
        }
      ]
    },
    {
      type: 'block-gls-info',
      children: [
        {
          type: 'p4',
          children: [
            {
              text: 'HGNC (2024/11/18)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'OMIM(2025/7/25)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'CLINVAR (2025/7/21)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'hg19 - gnomAD (v2.1)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'hg38 - gnomAD (v2.1 - liftover)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: '1000g (2015/08/26)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'EXAC (2015/11/29)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'gnomAD - MT (v3.1)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'hg19 - dbsnp (153)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'hg38 - dbsnp (156)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'CADD (v1.6)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'REVEL (v1.3)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'AlphaMissense (2023)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'SpliceAI (v1.3)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'Clingen (2024/8/4)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'dbVar (2024/2/16)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'DGV (2020/2/25)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'Exomiser (2023/11/4)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'Refseg Gene annotation (2024/1/29)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'Ensembl (2023/10/8)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'Mitomap (2025/7/30)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'genomeSV (latest)'
            }
          ]
        },
        {
          type: 'p4',
          children: [
            {
              text: 'decipher (latest)'
            }
          ]
        }
      ]
    },
    {
      type: 'paragraph',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'block-gls-footer',
      children: [
        {
          type: 'g2',
          children: [{ text: '报告署名/签章:' }]
        },
        {
          type: 'g2',
          children: [{ text: '报告日期:' }]
        }
      ]
    },
    {
      type: 'block-gls-footer',
      children: [
        {
          type: 'g2',
          children: [{ text: 'physician name,PhD.,Genomelight.' }]
        },
        {
          type: 'g2',
          children: [
            { text: formatDate(report?.createdAt, 'YYYY/MM/DD') ?? '-' }
          ]
        }
      ]
    },
    {
      type: 'paragraph',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'header3',
      children: [
        {
          text: '参考文献'
        }
      ]
    },
    {
      type: 'p4-center',
      children: [
        {
          text: ''
        }
      ]
    },
    {
      type: 'signature-footer',
      children: [
        {
          text: formatDate(report.createdAt, 'YYYY-MM-DD') ?? '-'
        }
      ]
    }
  ]
}
